import { Routes } from '@angular/router';
import { NotLoggedIndexComponent } from './pages/not-logged-index/not-logged-index.component';
import { PanelComponent } from './pages/panel/panel.component';
import { QuestionsComponent } from './pages/questions/questions.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { MySpaceComponent } from './pages/my-space/my-space.component';
import { authGuard } from './guards/auth.guard';
import { LoggedIndexComponent } from './pages/logged-index/logged-index.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { MyPlanComponent } from './pages/my-plan/my-plan.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { StatisticsComponent } from './subPages/statistics/statistics.component';
import { MyStatisticsComponent } from './pages/my-statistics/my-statistics.component';
import { authRedirectGuard } from './guards/auth-redirect.guard';
import { StudyEnvironmentComponent } from './pages/study-environment/study-environment.component';
import { UniqueQuestionPageComponent } from './pages/unique-question-page/unique-question-page.component';
import { ExamComponent } from './pages/exam/exam.component';
import { ExamsViewComponent } from './subPages/exams-view/exams-view.component';
import { ExamHistoryViewComponent } from './subPages/exam-history-view/exam-history-view.component';
import { QuestionsViewComponent } from './subPages/questions-view/questions-view.component';
import { TermsPageComponent } from './pages/terms-page/terms-page.component';
import { NewsComponent } from './pages/news/news.component';
import { ReadNewComponent } from './pages/read-new/read-new.component';

export const routes: Routes = [
    {
        'path': '', 
        component: NotLoggedIndexComponent,
        canActivate: [authRedirectGuard] 
    },
    {
        'path': 'home', 
        component: LoggedIndexComponent, 
        canActivate: [authGuard],
    },
    {
        'path': 'panel', 
        component: PanelComponent
    },
    {
        'path': 'news', 
        component: NewsComponent,
        canActivate: [authGuard],
    },
    {
        'path': 'news/:id', 
        component: ReadNewComponent, 
        canActivate: [authGuard],
    },
    {
        'path': 'questions', 
        component: QuestionsComponent,
        canActivate: [authGuard],
    },
    {
        'path': 'login', 
        component: LoginComponent,
        canActivate: [authRedirectGuard] 
    },
    {
        'path': 'signup', 
        component: SignupComponent,
        canActivate: [authRedirectGuard] 
    },
    {
        'path': 'terms', 
        component: TermsPageComponent,
    },
    {
        'path': 'my-space',
        component: MySpaceComponent,
        canActivate: [authGuard],
        children: [
            {path: 'profile', component : ProfileComponent},
            {path: 'my-plan', component : MyPlanComponent},
            {path: 'settings', component : SettingsComponent},
            {path: 'my-statistics', component : MyStatisticsComponent}
        ]
    },
    {
        'path': 'study-environment', 
        component: StudyEnvironmentComponent, 
        canActivate: [authGuard],
        children: [
            {path: 'exams-view', component : ExamsViewComponent},
            {path: 'results-view', component : ExamHistoryViewComponent},
            {path: 'questions-view', component : QuestionsViewComponent},
        ]
    },
    {
        'path': 'question/:qcode', 
        component: UniqueQuestionPageComponent, 
        canActivate: [authGuard],
    },
    {
        'path': 'exam/:eid', 
        component: ExamComponent, 
        canActivate: [authGuard],
    }
];
